import { Grid, Card, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import { REVIEW } from 'constants.js';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import DoneIcon from '@mui/icons-material/Done';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import BlockIcon from '@mui/icons-material/Block';
import { useMaterialUIController, setReviewContext } from "context";
import configurationContext from "contextConfig";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import { handleErrors, checkPrivilege, getProductImage } from "common.js";
import { PRIVILEGE } from "constants.js";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

function ProductReviews() {
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { reviewContext } = controller;
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [reviewData, setData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const [openDialog, setOpenDialog] = useState(false);
  const [commentContent, setCommentContent] = useState('');
  const searchFilterData = { 'statusFilter': reviewContext.statusFilter, 'ratingFilter': reviewContext.ratingFilter, "searchBy": reviewContext.searchBy, "searchValue": reviewContext.searchValue, "orderBy": reviewContext.orderBy, "orderValue": reviewContext.orderValue };
  const [isReviewContextChanged, setReviewContextChanged] = useState(false);

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const restrictStringLength = (str, maxLength = 30) => {
    if (str.length <= maxLength) {
      return str;
    }
    return str.substring(0, maxLength);
  }

  const changeStatus = async (id, status) => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: BASE + "api/product/updateReviewStatus/" + id + "/" + status,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const message = response.data.message;
        if (response.data.status == 1) {
          if (reviewData.data.rows) {
            const reviewRows = reviewData.data.rows;
            for (const reviewKey in reviewRows) {
              if (reviewRows[reviewKey]['id'] == id) {
                setData(prevState => {
                  const updatedreviewStatus = prevState.data.rows.map(item => {
                    if (item.id === id) {
                      return { ...item, status: status };
                    }
                    return item;
                  })
                  return {
                    ...prevState,
                    data: {
                      ...prevState.data,
                      rows: updatedreviewStatus
                    }
                  };
                });
              }
            }
          }
          if (status == 1)
            toast.success(t('Review approved successfully'));
          else
            if (status == 3)
              toast.success(t('Review rejected successfully'));
        }
        else {
          toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = (from = 0) => {
    setIsLoading(true);
    toast.dismiss();
    if (from == 1) {
      pageSelected = 1;
      navigate("/review/list");
    }
    axios({
      url: BASE + "api/product/listReviews",
      method: "POST",
      data: { ...searchFilterData, pageSelected: pageSelected },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      }
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
          if (response.data.data.totalCount)
            setResponseResultCount(response.data.data.totalCount);
        }
        else {
          toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo]);


  const handleResetFilters = () => {
    setReviewContext(dispatch, initialState.reviewContext);
    setReviewContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/review/list/page-1");
    else
      navigate("/review/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(reviewContext).some(
      key => reviewContext[key] !== initialState.reviewContext[key]
    );
    setReviewContextChanged(hasChanged);
  }, [reviewContext]);

  const columns = [
    { Header: t("image"), accessor: "image", align: "left" },
    { Header: t("customerEmail"), accessor: "email", align: "left" },
    { Header: t("shop name"), accessor: "shopName", align: "left" },
    { Header: t("productId"), accessor: "productId", align: "left" },
    { Header: t("productTitle"), accessor: "productTitle", align: "left" },
    { Header: t("comment"), accessor: "comment", align: "left" },
    { Header: t("rating"), accessor: "rating", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const finalObj = [];

  const generateActionLinks = (id, status) => {
    if (adminType == PRIVILEGE.SUBADMIN && !checkPrivilege("review", "write")) {
      return "-";
    }
    else if (status == REVIEW.APPROVED) {
      return (
        (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("review", "write")))) ?
          <MDTypography component="a" onClick={() => changeStatus(id, 3)}>
            <Tooltip title={t('reject')}><Box className="ActionBlock paddingRight5"><BlockIcon /></Box></Tooltip>
          </MDTypography>
          : null
      );
    }
    else if (status == REVIEW.PENDING_REVIEW) {
      return (
        (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("review", "write")))) ?
          <>
            <MDTypography component="a" onClick={() => changeStatus(id, 1)}>
              <Tooltip title={t('approve')}><Box className="ActionApprove paddingRight5"><DoneIcon /></Box></Tooltip>
            </MDTypography>
            <MDTypography component="a" onClick={() => changeStatus(id, 3)}>
              <Tooltip title={t('reject')}><Box className="ActionBlock paddingRight5"><BlockIcon /></Box></Tooltip>
            </MDTypography>
          </>
          : null
      );
    }
    else if (status == REVIEW.REJECTED) {
      return (
        (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("review", "write")))) ?
          <MDTypography component="a" onClick={() => changeStatus(id, 1)}>
            <Tooltip title={t('approve')}><Box className="ActionApprove"><DoneIcon /></Box></Tooltip>
          </MDTypography>
          : null
      );
    }
  }

  const handleShowCommentOpen = (event, comment) => {
    setCommentContent(comment);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  if (reviewData.data && reviewData.data.rows) {
    let reviewRecords = reviewData.data.rows;
    for (const rowKey in reviewData.data.rows) {
      let reviewRecord = reviewRecords[rowKey];
      if (reviewRecord.id > 0) {
        let tempObj = {
          image: <MDBox component="img" src={getProductImage(reviewRecord.images)} className="profileThumbImage" />,
          email: reviewRecord.email,
          shopName: reviewRecord.shopName,
          shopifyid: (reviewRecord.shopifyProductId > 0) ? reviewRecord.shopifyProductId : t('na'),
          productId: (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("product", "read")))) ?
            <MDTypography component="a" href={"#"} onClick={(event) => { event.preventDefault(); navigate("/products/edit/" + reviewRecord.productId) }} variant="caption" color="text" fontWeight="medium">{'#' + reviewRecord.productId}</MDTypography>
            :
            '#' + reviewRecord.productId,
          productTitle: reviewRecord.productTitle,
          comment: reviewRecord.comment ?
            <MDTypography className="reviewComment" component="label" variant="caption" color="text" fontWeight="medium" onClick={(event) => handleShowCommentOpen(event, reviewRecord.comment)} >
              {restrictStringLength(reviewRecord.comment, 20)}<ReadMoreIcon />
            </MDTypography>
            : '-',
          rating: reviewRecord.rating,
          status: <span className={'statusD' + reviewRecord.status}>
            {(reviewRecord.status == REVIEW.REJECTED) ? <span>{t('rejected')}</span> :
              (reviewRecord.status == REVIEW.APPROVED) ? <span>{t('approved')}</span> :
                (reviewRecord.status == REVIEW.PENDING_REVIEW) ? <span>{t('pending review')}</span> : null}</span>,
          action: <span className="actionLinksStyle">
            {generateActionLinks(reviewRecord.id, reviewRecord.status)}
          </span>
        };
        finalObj.push(tempObj);
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("manageReviews")} />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(reviewData).length > 0) ?
        <Card>
          <MDBox className="ManageProductTopSec ReviewFilterBox" mx={2} mt={0} py={3} px={2} variant="gradient">
            <Grid container className="FilterSectionBox ReviewFilterSectionBox" spacing={2}>
              <Grid item xs={12} sm={2} md={2} >
                <MDInput
                  select
                  name="statusFilter"
                  label={t('status')}
                  value={searchFilterData.statusFilter}
                  InputProps={{
                    classes: { root: "filterStyle" },
                  }}
                  className="ManageProductTopSecip"
                  onChange={(obj) => {
                    setReviewContext(dispatch, { ...reviewContext, statusFilter: obj.target.value });
                  }} fullWidth
                >
                  <MenuItem value="0">{t('all')}</MenuItem>
                  <MenuItem value={1}>{t('approved')}</MenuItem>
                  <MenuItem value={2}>{t('pending')}</MenuItem>
                  <MenuItem value={3}>{t('rejected')}</MenuItem>
                </MDInput>
              </Grid>
              <Grid item xs={12} sm={1} md={1} >
                <MDInput
                  select
                  name="ratingFilter"
                  label={t('rating')}
                  value={searchFilterData.ratingFilter}
                  InputProps={{
                    classes: { root: "filterStyle" },
                  }}
                  className="ManageProductTopSecip"
                  onChange={(obj) => {
                    setReviewContext(dispatch, { ...reviewContext, ratingFilter: obj.target.value });
                  }} fullWidth
                >
                  <MenuItem value={'all'}>{t('all')}</MenuItem>
                  <MenuItem value={1}>{'*'}</MenuItem>
                  <MenuItem value={2}>{'**'}</MenuItem>
                  <MenuItem value={3}>{'***'}</MenuItem>
                  <MenuItem value={4}>{'****'}</MenuItem>
                  <MenuItem value={5}>{'*****'}</MenuItem>
                </MDInput>
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <MDInput
                  select
                  name="searchBy"
                  label={t('searchBy')}
                  value={searchFilterData.searchBy}
                  InputProps={{
                    classes: { root: "filterStyle" },
                  }}
                  onChange={(obj) => {
                    if (obj.target.value == 'none')
                      setReviewContext(dispatch, { ...reviewContext, searchValue: '', searchBy: obj.target.value });
                    else
                      setReviewContext(dispatch, { ...reviewContext, searchBy: obj.target.value });
                  }} fullWidth
                >
                  <MenuItem value={'none'}>{t('none')}</MenuItem>
                  <MenuItem value={'productId'}>{t('product id')}</MenuItem>
                  <MenuItem value={'title'}>{t('productTitle')}</MenuItem>
                  <MenuItem value={'shopName'}>{t('shop name')}</MenuItem>
                  <MenuItem value={'email'}>{t('email')}</MenuItem>
                </MDInput>
              </Grid>
              <Grid item xs={12} sm={2} md={2} >
                <FormControl >
                  <MDInput
                    key={'searchValue'}
                    value={searchFilterData.searchValue}
                    disabled={(searchFilterData.searchBy == 'none') ? true : false}
                    type="text" name="searchValue" label={t('searchInput')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(obj) => {
                      setReviewContext(dispatch, { ...reviewContext, searchValue: obj.target.value });
                    }} fullWidth />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <MDInput
                  select
                  name="orderBy"
                  value={searchFilterData.orderBy}
                  InputProps={{
                    classes: { root: "filterStyle" },
                  }}
                  label={t('orderBy')}
                  onChange={(obj) => {
                    setReviewContext(dispatch, { ...reviewContext, orderBy: obj.target.value });
                  }} fullWidth
                >
                  <MenuItem value={'createdAt'}>{t('createdAt')}</MenuItem>
                </MDInput>
              </Grid>
              <Grid item xs={12} sm={1} md={1}>
                <MDInput
                  select
                  name="orderValue"
                  value={searchFilterData.orderValue}
                  InputProps={{
                    classes: { root: "filterStyle" },
                  }}
                  label={t('order')}
                  onChange={(obj) => {
                    setReviewContext(dispatch, { ...reviewContext, orderValue: obj.target.value });
                  }}
                  fullWidth
                >
                  <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                  <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                </MDInput>
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <FormControl className="filterSubmit">
                  <MDButton disableRipple
                    onClick={() => {
                      navigate("/review/list");
                      if (typeof pageNo === "undefined")
                        data(1);
                    }}
                    key="submit" type="submit" color="info" size="small" className="SubmitButton" fullWidth>{t('submit')}</MDButton>
                  {isReviewContextChanged && (
                    <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox pt={3}>
            <DataTable
              table={{ columns, rows }}
              isSorted={false}
              showTotalEntries={true}
              responseResultCount={responseResultCount}
              paginationSize={MyContext.paginationSize}
              paginationLink={"/review/list/page-"}
              pageSelected={pageSelected}
            />
          </MDBox>
          <Dialog open={openDialog} onClose={handleCloseDialog} className="reviewComment">
            <DialogTitle>{t("reviewComment")}</DialogTitle>
            <DialogContent dividers className="generalFont">
              {commentContent}
            </DialogContent>
            <DialogActions>
              <MDButton disableRipple onClick={handleCloseDialog}>{t("close")}</MDButton>
            </DialogActions>
          </Dialog>
        </Card>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ProductReviews;
